export const logoUrlSource = process.env.VUE_APP_FONTS + '/fe/fsw-common-res/default/logo'

export const logobt_cn = `${logoUrlSource}/bt_cn.png`
export const logobt_tc = `${logoUrlSource}/bg_tc.png`
export const logo2x = `${logoUrlSource}/logo@2x.png`
export const logo3x = `${logoUrlSource}/logo@3x.png`
export const invite_bg = `${logoUrlSource}/invite_bg.png`